import { createWebHistory, createRouter } from 'vue-router'
import routes from './routes.ts'
import { layoutMiddleware } from '@/middlewares/layoutMiddleware.ts'
import { isAuth } from '@/middlewares/isAuth.ts'
import { preserveTable } from '@/middlewares/preserveTable.ts'
import { isChunkLoadError, reloadForFreshChunks } from '@/utils/chunkReload'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  to.meta.from = from
  next()
})
router.beforeEach(isAuth)
router.beforeEach(layoutMiddleware)
router.beforeEach(preserveTable)

/**
 * It must decide stale-SPA-after-deploy problem
 */
router.onError((error, to) => {
  if (isChunkLoadError(error)) reloadForFreshChunks(to.fullPath)
})

export default router
